// ...existing code...
import React from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import { Error } from '../../../components';
import { useSelector, useDispatch } from 'react-redux';
import { renderTelephoneNumber } from '../../../utils/utils';
import AddBlock from './add/AddBlock';
import NumberBlocksGeneralForm from './edit/General';
import Allocations from './edit/Allocations';
import CustomFieldsForm from './edit/Custom';
import Admin from './edit/Admin';
import AGGridMain from '@/components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';
import { Button, HStack, IconButton, Tooltip } from '@chakra-ui/react';
import { MdAdd, MdSwapHoriz } from 'react-icons/md';
import SplitJoinBlock from './split-join/SplitJoinBlock';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    AlertIcon,
    Box,
    FormErrorMessage,
    InputGroup,
    InputRightElement,
    Stack,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Alert, Icon } from 'components/v4';
import { axios } from '@/services/axios';
import { FormControl, FormLabel, Input } from 'components/v4';
import FormBase from 'components/forms/new/FormBase';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    Tabs as ChakraTabs,
    TabList,
    TabPanels,
    Tab as ChakraTab,
    TabPanel as ChakraTabPanel,
} from '@chakra-ui/react';
import {
    customTabStylesCombineTheme,
    selectedTabStylesCombineTheme,
} from '@/constants';
import { nullError } from 'components/error';
import walkthroughIds from './walkthroughIds';
import { SearchIcon, EditIcon, ArrowBackIcon } from '@chakra-ui/icons';
import { isEmpty } from 'lodash';
import ActionMenu from 'components/presentational/ActionMenu';
import ActionsButton from '@/components/tables/AGGrid/ActionsButton';
import LoadingFieldDropdown from '@/components/forms/LoadingFieldDropdown';
import { Scope } from 'utils/enums/ScopeType';
import useAutoBackOnManagingChange from 'hooks/useAutoBackOnManagingChange';
import OrdersTab from './orders/OrdersTab';

/*
 * Component for the Number Blocks Tab of the Sidebar options
 */

function NumberBlocks() {
    // Split/Join modal state
    const [isSplitJoinOpen, setIsSplitJoinOpen] = useState(false);
    const [splitJoinId, setSplitJoinId] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Reload page when Currently Managing changes
    useAutoBackOnManagingChange({
        enabled: true,
        onBack: () => window.location.reload(),
    });

    // Store all blocks for parent dropdown
    const [parentArray, setParentArray] = React.useState([]);

    // ...existing code...

    // blocksData is defined below, so set parentArray after blocksData is defined

    const handleEdit = React.useCallback(
        (row) => {
            // Set parent array for the block dropdown, then open child
            dispatch({ type: 'CHANGE_PARENT_TABLE', payload: parentArray });
            dispatch({ type: 'SWITCH_CHILD_TABLE', payload: 0 });
            dispatch({ type: 'OPEN_CHILD_TABLE', payload: { ...row, tab: 0 } });
        },
        [dispatch, parentArray],
    );
    // ...existing code...
    const tabList = ['Search', 'Number Blocks'];
    const tableRef = useRef(null);
    // const { isOpen, onOpen, onClose } = useDisclosure();

    // All hooks at the top, before any early returns
    // Removed nbID and state, not needed after modal removal
    // Redux-based child view state
    const { child } = useSelector((state) => state.table);
    const { breadcrumb } = useSelector((state) => state.view);
    const [loadList, setLoadList] = useState(false);
    // Land on the Orders tab when returning from the Order Details route
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(
        location.state?.openOrdersTab ? 2 : 0,
    );
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [value, setValue] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    // Draft state for tab persistence: { [id]: { general: {...}, custom: {...} } }
    const [formDrafts, setFormDrafts] = useState({});

    // Helper to get/set draft for a given tab and record
    const getDraft = (tab, id) => formDrafts[id]?.[tab] || {};
    const setDraft = (tab, id, draft) => {
        setFormDrafts((prev) => ({
            ...prev,
            [id]: {
                ...(prev[id] || {}),
                [tab]: draft,
            },
        }));
    };

    const handleChange = (event) => {
        setErrorMessage(null);
        setIsError(false);
        // Strip all non-numeric characters (handles both typing and pasting)
        const sanitizedValue = event.target.value.replace(/[^0-9]/g, '');
        setValue(sanitizedValue);
    };

    const {
        ufAddButton,
        ufTabButton,
        ufInputSearch,
        ufInputClearButton,
        ufSearchButton,
    } = walkthroughIds;

    // state access
    // Only use modalMode for Add modal, not for edit
    const modalState = useSelector((state) => state.modal.mode);

    const { requiredScope, currentScope } = useSelector((state) => {
        return { ...state.login };
    });

    const showOrdersTab = requiredScope >= 60;

    const { currentWholesaler, currentPartner } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const { darkMode } = useSelector((state) => state.settings);

    const handleSplitJoin = React.useCallback((row) => {
        setSplitJoinId(row.id);
        setIsSplitJoinOpen(true);
    }, []);

    // default columns for the number blocks table (list tab)
    // handleEdit and handleSplitJoin are stable, so safe to omit from deps
    const baseDefaultColumns = useMemo(() => {
        const columns = [
            {
                headerName: 'Wholesaler',
                field: 'wholesalerName',
                hide: true,
            },
            {
                headerName: 'Partner',
                field: 'partnerName',
                hide: true,
            },
            {
                headerName: 'Company',
                field: 'companyName',
                flex: 1,
            },
            {
                headerName: 'Block Size',
                field: 'blockSize',
                valueGetter: (params) =>
                    params.data?.blockSize != null
                        ? Number(params.data.blockSize)
                        : null,
                comparator: (a, b) => (a ?? 0) - (b ?? 0),
                width: 120,
                sort: 'asc',
            },
            {
                headerName: 'First Number',
                field: 'first',
                valueGetter: (params) => params.data?.first,
                valueFormatter: (params) =>
                    params.data
                        ? renderTelephoneNumber(params.data, 'first')
                        : '',
                width: 180,
                enableRowGroup: true,
                filter: true,
                suppressHeaderMenuButton: true,
                suppressHeaderFilterButton: false,
            },
            {
                headerName: 'Last Number',
                field: 'last',
                valueGetter: (params) => params.data?.last,
                valueFormatter: (params) =>
                    params.data
                        ? renderTelephoneNumber(params.data, 'last')
                        : '',
                width: 180,
                enableRowGroup: true,
                filter: true,
                suppressHeaderMenuButton: true,
                suppressHeaderFilterButton: false,
            },
            {
                headerName: 'Inbound Carrier',
                field: 'inboundCarrier',
            },
            {
                headerName: 'Outbound Carrier',
                field: 'outboundCarrier',
            },
            {
                headerName: 'Public Pool',
                field: 'publicPool',
                cellDataType: 'boolean',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 1',
                field: 'attribute1',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 2',
                field: 'attribute2',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 3',
                field: 'attribute3',
                hide: true,
            },
            {
                headerName: 'Action',
                headerClass: 'ag-action-header-center',
                lockPosition: 'right',
                maxWidth: 100,
                filter: false,
                suppressMovable: true,
                lockVisible: true,
                suppressColumnsToolPanel: true,
                suppressHeaderMenuButton: true,
                suppressHeaderFilterButton: true,
                enableRowGroup: false,
                resizable: false,
                sortable: false,
                cellStyle: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                cellRenderer: (params) => {
                    const row = params.data;
                    const actionItems = [
                        {
                            label: 'Edit',
                            onClick: () => handleEdit(row),
                            icon: EditIcon,
                        },
                        {
                            label: 'Split/Join Block',
                            onClick: () => handleSplitJoin(row),
                            icon: MdSwapHoriz,
                        },
                    ];

                    return (
                        <HStack
                            spacing={0}
                            justifyContent="center"
                            alignItems="center"
                            width="100%"
                            height="100%">
                            <Tooltip
                                label="Edit Block"
                                portalProps={{
                                    containerRef: undefined,
                                }}>
                                <ActionMenu actionItems={actionItems} />
                            </Tooltip>
                        </HStack>
                    );
                },
            },
        ];
        return columns;
    }, [handleEdit, handleSplitJoin]);

    // Fetch number blocks list using TanStack Query
    const getBlocksUrl = () => {
        if (currentScope === 40) {
            return `/partner/${currentPartner}/numberblocks/list`;
        } else if (currentScope === 60) {
            return `/numberblocks/list/${currentWholesaler}`;
        } else if (currentScope === 80) {
            return '/numberblocks/list';
        }
        return '';
    };

    const {
        data: blocksData = [],
        isLoading: blocksLoading,
        refetch: refetchBlocks,
    } = useQuery({
        queryKey: ['numberBlocks', currentScope],
        queryFn: async () => {
            //dispatch({ type: 'CHANGE_TABLE_LOADING' });
            const url = getBlocksUrl();
            if (!url) return [];
            const res = await axios.get(url);
            dispatch({ type: 'CHANGE_TABLE_LOADING' });
            return res.data;
        },
        enabled: tabIndex === 1 && loadList,
        staleTime: 0,
    });

    // When blocksData loads, update parentArray for dropdown
    useEffect(() => {
        if (blocksData && Array.isArray(blocksData) && blocksData.length > 0) {
            setParentArray(blocksData);
        }
    }, [blocksData]);

    // search tab columns
    const baseSearchColumns = useMemo(() => {
        var columns = [
            {
                headerName: 'Wholesaler',
                field: 'wholesaler',
                hide: true,
            },
            {
                headerName: 'Partner',
                field: 'partner',
                hide: true,
            },
            {
                headerName: 'Company',
                field: 'company',
            },
            {
                headerName: 'Block Size',
                field: 'blockSize',
                valueGetter: (params) =>
                    params.data?.blockSize != null
                        ? Number(params.data.blockSize)
                        : null,
                comparator: (a, b) => (a ?? 0) - (b ?? 0),
                width: '10%',
                sort: 'asc',
            },
            {
                headerName: 'First Number',
                field: 'first',
                valueFormatter: (params) =>
                    renderTelephoneNumber(params.data, 'first'),
            },
            {
                headerName: 'Last Number',
                field: 'last',
                valueFormatter: (params) =>
                    renderTelephoneNumber(params.data, 'last'),
            },
            {
                headerName: 'Inbound Carrier',
                field: 'inboundCarrier',
            },
            {
                headerName: 'Outbound Carrier',
                field: 'outboundCarrier',
            },
            {
                headerName: 'Public Pool',
                field: 'publicPool',
                cellDataType: 'boolean',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 1',
                field: 'attribute1',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 2',
                field: 'attribute2',
                hide: true,
            },
            {
                headerName: 'Custom Attribute 3',
                field: 'attribute3',
                hide: true,
            },
            {
                headerName: 'Action',
                headerClass: 'ag-action-header-center',
                lockPosition: 'right',
                maxWidth: 100,
                sortable: false,
                filter: false,
                suppressMovable: true,
                lockVisible: true,
                suppressColumnsToolPanel: true,
                suppressHeaderMenuButton: true,
                suppressHeaderFilterButton: true,
                enableRowGroup: false,
                resizable: false,
                field: 'actions',
                cellStyle: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                cellRenderer: (params) => {
                    const row = params.data;
                    const actionItems = [
                        {
                            label: 'Edit',
                            onClick: () => {
                                setParentArray(searchResults);
                                dispatch({
                                    type: 'CHANGE_PARENT_TABLE',
                                    payload: searchResults,
                                });
                                dispatch({
                                    type: 'SWITCH_CHILD_TABLE',
                                    payload: 0,
                                });
                                dispatch({
                                    type: 'OPEN_CHILD_TABLE',
                                    payload: {
                                        ...row,
                                        wholesalerName: row.wholesaler,
                                        partnerName: row.partner,
                                        companyName: row.company,
                                        tab: 0,
                                        parent: searchResults,
                                    },
                                });
                                dispatch({
                                    type: 'OPEN_MODAL',
                                    payload: {
                                        data: { id: row.id },
                                        mode: 'Edit',
                                        loading: false,
                                        state: {
                                            noNeedPrompt: true,
                                        },
                                    },
                                });
                            },
                            icon: EditIcon,
                        },
                        ...(row.blockSize === 100
                            ? [
                                  {
                                      label: 'Split/Join Block',
                                      onClick: () => handleSplitJoin(row),
                                      icon: MdSwapHoriz,
                                  },
                              ]
                            : []),
                    ];

                    return (
                        <ActionsButton
                            actions={actionItems}
                            menuLabel="Edit Block"
                        />
                    );
                },
            },
        ];
        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentScope, searchResults, dispatch, handleSplitJoin]);

    const { columns: defaultColumns, onColumnVisible: onDefaultColumnVisible } =
        useColumnState(baseDefaultColumns);
    const { columns: searchColumns, onColumnVisible: onSearchColumnVisible } =
        useColumnState(baseSearchColumns);

    const searchTableData = useMemo(
        () => ({
            columns: searchColumns,
            data: searchResults,
        }),
        [searchColumns, searchResults],
    );

    const defaultTableData = useMemo(
        () => ({
            columns: defaultColumns,
            data: (blocksData || [])
                .map((row) =>
                    row != null && row.blockSize != null
                        ? { ...row, blockSize: Number(row.blockSize) }
                        : row,
                )
                .sort(
                    (a, b) =>
                        (Number(a?.blockSize) || 0) -
                        (Number(b?.blockSize) || 0),
                ),
        }),
        [defaultColumns, blocksData],
    );

    useEffect(() => {
        if (tabIndex === 1 && !loadList) {
            setLoadList(true);
        }
    }, [tabIndex, loadList]);

    const handleClear = () => {
        setIsError(false);
        setErrorMessage('');
        setShowTable(false);
        setValue('');
        dispatch({
            type: 'RESET_TABLE_MULTICHILD',
        });
    };

    if (!currentWholesaler || !currentPartner) {
        return <Error error={nullError} />;
    }

    // Only show AddBlock modal if modalMode is Add
    if (modalState === 'Add') {
        return (
            <AddBlock
                handleBack={handleClear}
                onSuccess={() => dispatch({ type: 'RESET_TABLE_MULTICHILD' })}
                onBack={() => {
                    // Don't reload - just reset the modal state to show the search page
                    dispatch({ type: 'CLOSE_MODAL' });
                    dispatch({ type: 'RESET_MODAL' });
                }}
                onGoToOrders={
                    showOrdersTab
                        ? () => {
                              dispatch({ type: 'CLOSE_MODAL' });
                              dispatch({ type: 'RESET_MODAL' });
                              // Tabs: Search=0, Number Blocks=1, Orders=2
                              setTabIndex(2);
                          }
                        : undefined
                }
            />
        );
    }

    // Patch handleSearch to set searchResults and isLoading
    const handleSearchPatched = async () => {
        dispatch({ type: 'RESET_TABLE_MULTICHILD' });
        if (value) {
            setIsError(false);
            let searchValue = value;
            // Ignore leading plus sign if present
            if (searchValue.startsWith('+')) {
                searchValue = searchValue.substring(1);
            }
            if (searchValue.length > 15) {
                setErrorMessage('Invalid telephone number.');
                setIsError(true);
                return;
            }
            try {
                setShowTable(true);
                setIsLoading(true);
                const result = await axios.get(
                    '/NumberBlock/Find?telephoneNumber=' + searchValue,
                );
                // Map API response to match table column field names
                const mappedData = {
                    ...result.data,
                    wholesaler:
                        result.data.wholesalerName || result.data.wholesaler,
                    partner: result.data.partnerName || result.data.partner,
                    company: result.data.companyName || result.data.company,
                };
                setSearchResults([mappedData]);
                setIsLoading(false);
            } catch (e) {
                setIsLoading(false);
                setErrorMessage(e.response?.data?.message || 'Error');
                setIsError(true);
            }
        } else {
            setShowTable(false);
            setErrorMessage('Field is required.');
            setIsError(true);
        }
    };

    // Patch handleClear to clear searchResults
    const handleClearPatched = () => {
        setIsError(false);
        setErrorMessage('');
        setShowTable(false);
        setValue('');
        setSearchResults([]);
        dispatch({ type: 'RESET_TABLE_MULTICHILD' });
    };

    // Child view for editing a block
    if (child) {
        const recordId = child?.id;
        const childTabs = [
            {
                label: 'Details',
                component: (
                    <NumberBlocksGeneralForm
                        child={child}
                        multiChildValue={child}
                        formDraft={getDraft('general', recordId)}
                        setFormDraft={(draft) =>
                            setDraft('general', recordId, draft)
                        }
                        onSuccess={() => {
                            setDraft('general', recordId, {});
                            refetchBlocks();
                            dispatch({ type: 'RESET_TABLE_MULTICHILD' });
                        }}
                        onBack={() => {
                            dispatch({ type: 'RESET_TABLE_MULTICHILD' });
                        }}
                    />
                ),
            },
            ...(requiredScope !== 20
                ? [
                      {
                          label: 'Custom',
                          component: (
                              <CustomFieldsForm
                                  child={child}
                                  multiChildValue={child}
                                  formDraft={getDraft('custom', recordId)}
                                  setFormDraft={(draft) =>
                                      setDraft('custom', recordId, draft)
                                  }
                                  onSuccess={() => {
                                      setDraft('custom', recordId, {});
                                      refetchBlocks();
                                      dispatch({
                                          type: 'RESET_TABLE_MULTICHILD',
                                      });
                                  }}
                                  onBack={() => {
                                      window.location.reload();
                                      dispatch({
                                          type: 'RESET_TABLE_MULTICHILD',
                                      });
                                  }}
                              />
                          ),
                      },
                  ]
                : []),
            ...(requiredScope !== 40 && requiredScope !== 20
                ? [
                      {
                          label: 'Admin',
                          component: (
                              <Admin
                                  child={child}
                                  multiChildValue={child}
                                  reset={() => {
                                      // The deleted block otherwise lingers in
                                      // search results (plain state, not a
                                      // query) and in the main table until a
                                      // manual refresh.
                                      setSearchResults((prev) =>
                                          prev.filter(
                                              (row) => row.id !== child?.id,
                                          ),
                                      );
                                      refetchBlocks();
                                      dispatch({ type: 'RESET_CHILD_TABLE' });
                                  }}
                              />
                          ),
                      },
                  ]
                : []),
            {
                label: 'Allocations',
                component: (
                    <Allocations child={child} multiChildValue={child} />
                ),
            },
        ];
        return (
            <>
                {/* Header with back arrow and number selection dropdown */}
                <HStack spacing={3} mb={4} alignItems="center">
                    <IconButton
                        aria-label="Back to Number Blocks"
                        icon={<ArrowBackIcon />}
                        variant="ghost"
                        size="sm"
                        onClick={() => {
                            dispatch({ type: 'RESET_TABLE_MULTICHILD' });
                        }}
                    />
                    <Text
                        sx={{
                            fontSize: '20',
                            fontWeight: '500',
                            color: darkMode ? '#FFFFFF' : '#262626',
                        }}>
                        Edit Number Block
                    </Text>
                    <Text
                        sx={{
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            color: darkMode ? '#FFFFFF' : '#262626',
                        }}>
                        &gt;
                    </Text>
                    <Box
                        minWidth="300px"
                        sx={{
                            '& .MuiAutocomplete-inputRoot': {
                                height: '36px',
                                fontFamily: 'Inter',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: darkMode ? '#FFFFFF' : '#262626',
                                display: 'flex',
                                alignItems: 'center',
                            },
                            '& .MuiInputBase-root': {
                                height: '36px',
                                fontFamily: 'Inter',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: darkMode ? '#FFFFFF' : '#262626',
                                display: 'flex',
                                alignItems: 'center',
                            },
                            '& .MuiInputBase-input': {
                                fontFamily: 'Inter',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: darkMode ? '#FFFFFF' : '#262626',
                                paddingTop: '4px',
                            },
                            '& .MuiAutocomplete-option': {
                                fontFamily: 'Inter',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: darkMode ? '#FFFFFF' : '#262626',
                            },
                        }}>
                        <LoadingFieldDropdown
                            dropDownValue="id"
                            displayField="first"
                            staticEnum={parentArray}
                            onDisplayDropdown={(value) => {
                                if (!value) return '';
                                const { first, last } = value;
                                if (first === last) {
                                    return `+${first}`;
                                }
                                return `+${first} to +${last}`;
                            }}
                            onChange={(v) => {
                                const childData = (parentArray || []).find(
                                    (parentValue) =>
                                        String(parentValue.id) === String(v),
                                );
                                if (childData) {
                                    dispatch({
                                        type: 'CHANGE_PARENT_TABLE',
                                        payload: parentArray,
                                    });
                                    dispatch({
                                        type: 'OPEN_CHILD_TABLE',
                                        payload: {
                                            ...childData,
                                            tab: 0,
                                            parent: parentArray,
                                        },
                                    });
                                    dispatch({
                                        type: 'SWITCH_CHILD_TABLE',
                                        payload: 0,
                                    });
                                }
                            }}
                            searchable
                            noEmptyOption
                            fieldValue={
                                child &&
                                child.id !== undefined &&
                                child.id !== null
                                    ? String(child.id)
                                    : ''
                            }
                        />
                    </Box>
                </HStack>
                <ChakraTabs
                    index={Number.isInteger(breadcrumb) ? breadcrumb : 0}
                    onChange={(index) =>
                        dispatch({
                            type: 'SWITCH_CHILD_TABLE',
                            payload: index,
                        })
                    }>
                    <TabList borderBottom="none">
                        {childTabs.map(({ label }) => (
                            <ChakraTab
                                key={label}
                                data-walkthroughid={ufTabButton + label}
                                onMouseDown={(e) =>
                                    e.button === 2 && e.preventDefault()
                                }
                                sx={{
                                    ...customTabStylesCombineTheme,
                                    color: darkMode
                                        ? 'rgba(255, 255, 255)'
                                        : '#262626',
                                }}
                                _selected={{
                                    ...selectedTabStylesCombineTheme,
                                    textColor: darkMode
                                        ? 'rgba(255, 255, 255)'
                                        : '#262626',
                                }}>
                                {label}
                            </ChakraTab>
                        ))}
                    </TabList>
                    {/*
                     * Not `isLazy`: every panel stays mounted so switching tabs
                     * does not remount the Allocations grid and refetch it.
                     */}
                    <TabPanels padding={0}>
                        {childTabs.map(({ label, component }) => (
                            <ChakraTabPanel key={label} p={0}>
                                {component}
                            </ChakraTabPanel>
                        ))}
                    </TabPanels>
                </ChakraTabs>
            </>
        );
    }

    // Main table view
    return (
        <>
            <Text
                sx={{
                    fontSize: '20',
                    fontWeight: '500',
                    marginBottom: '15px',
                    color: darkMode ? '#FFFFFF' : '#262626',
                }}>
                Number Blocks
            </Text>
            {requiredScope > 40 && (
                <HStack spacing={2} mb="1%">
                    <Button
                        className="btn btn-primary btn-sm"
                        data-walkthroughid={ufAddButton}
                        onClick={() => {
                            dispatch({ type: 'RESET_MODAL' });
                            dispatch({
                                type: 'OPEN_MODAL',
                                payload: {
                                    state: {
                                        numberBlockPortingType: 0,
                                        wholesalerID: currentWholesaler,
                                        noNeedPrompt: true,
                                    },
                                    loading: false,
                                    mode: 'Add',
                                    hash: '',
                                },
                            });
                            dispatch({ type: 'CHANGE_MODAL_HASH' });
                        }}>
                        <Icon as={MdAdd} sx={{ marginBottom: '2%' }} /> Number
                        Blocks
                    </Button>

                    {requiredScope >= 80 && (
                        <Tooltip
                            label="CSV Update"
                            placement="bottom"
                            hasArrow
                            portalProps={{ containerRef: undefined }}>
                            <div
                                style={{
                                    position: 'relative',
                                    display: 'inline-block',
                                }}>
                                <Button
                                    className="btn btn-primary btn-sm"
                                    width="110px"
                                    onClick={() => {
                                        navigate('/number-blocks/csv');
                                    }}>
                                    CSV Update
                                </Button>
                            </div>
                        </Tooltip>
                    )}
                </HStack>
            )}
            <ChakraTabs
                isLazy
                index={tabIndex}
                onChange={(index) => {
                    if (tabIndex === 1) {
                        dispatch({ type: 'CHANGE_TABLE_LOADING' });
                        // handleListClearPatched();
                    } else {
                        dispatch({ type: 'CHANGE_TABLE_LOADING' });
                        handleClearPatched();
                    }
                    setTabIndex(index);
                }}>
                <TabList borderBottom="none">
                    {tabList.map((tab, index) => (
                        <ChakraTab
                            data-walkthroughid={ufTabButton + tab}
                            key={index}
                            onMouseDown={(e) =>
                                e.button === 2 && e.preventDefault()
                            }
                            sx={{
                                ...customTabStylesCombineTheme,
                                color: darkMode
                                    ? 'rgba(255, 255, 255)'
                                    : '#262626',
                            }}
                            _selected={{
                                ...selectedTabStylesCombineTheme,
                                textColor: darkMode
                                    ? 'rgba(255, 255, 255)'
                                    : '#262626',
                            }}>
                            {tab}
                        </ChakraTab>
                    ))}
                    {showOrdersTab && (
                        <ChakraTab
                            data-walkthroughid={`${ufTabButton}Orders`}
                            onMouseDown={(e) =>
                                e.button === 2 && e.preventDefault()
                            }
                            sx={{
                                ...customTabStylesCombineTheme,
                                color: darkMode
                                    ? 'rgba(255, 255, 255)'
                                    : '#262626',
                            }}
                            _selected={{
                                ...selectedTabStylesCombineTheme,
                                textColor: darkMode
                                    ? 'rgba(255, 255, 255)'
                                    : '#262626',
                            }}>
                            Orders
                        </ChakraTab>
                    )}
                </TabList>
                <TabPanels padding={0}>
                    <ChakraTabPanel p={0}>
                        <Box>
                            <FormBase
                                initialValues={{ telephoneNumber: value }}
                                finalFormSubmit={() => {}}
                                hideSubmitButton={true}
                                noBackBtn={true}>
                                {() => (
                                    <Box>
                                        <FormControl
                                            sx={{ margin: '0 !important' }}
                                            isInvalid={isError}
                                            onMouseEnter={() =>
                                                setIsHovered(true)
                                            }
                                            onMouseLeave={() =>
                                                setIsHovered(false)
                                            }>
                                            <Stack
                                                direction="row"
                                                spacing={stackSpacing}
                                                align="flex-start"
                                                sx={stackStyling(true)}>
                                                <Box>
                                                    <FormLabel
                                                        sx={formLabelStyling(
                                                            darkMode,
                                                        )}>
                                                        Telephone Number
                                                    </FormLabel>
                                                    <Text
                                                        sx={descriptionStyling}
                                                        maxWidth={250}>
                                                        Search for a number in
                                                        E.164 format.
                                                    </Text>
                                                </Box>
                                                <Box
                                                    flex="1"
                                                    minWidth={0}
                                                    pt={2}>
                                                    <VStack
                                                        width="100%"
                                                        alignItems="normal"
                                                        marginTop="8px">
                                                        <InputGroup mb={10}>
                                                            <Input
                                                                data-walkthroughid={
                                                                    ufInputSearch
                                                                }
                                                                value={value}
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                onKeyPress={(
                                                                    event,
                                                                ) => {
                                                                    if (
                                                                        !/[0-9]/.test(
                                                                            event.key,
                                                                        )
                                                                    ) {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                onKeyDown={(
                                                                    e,
                                                                ) => {
                                                                    if (
                                                                        e.key ===
                                                                        'Enter'
                                                                    ) {
                                                                        e.preventDefault();
                                                                        handleSearchPatched();
                                                                    }
                                                                }}
                                                                placeholder="e.g. 6113007465426"
                                                            />
                                                            {isEmpty(value) && (
                                                                <InputRightElement pointerEvents="none">
                                                                    <SearchIcon color="gray.300" />
                                                                </InputRightElement>
                                                            )}
                                                        </InputGroup>
                                                        {isError && (
                                                            <FormErrorMessage>
                                                                {errorMessage}
                                                            </FormErrorMessage>
                                                        )}
                                                    </VStack>
                                                </Box>
                                                {isHovered && (
                                                    <FieldToolTip
                                                        label="Enter a telephone number to search for number blocks."
                                                        ariaLabel="telephone-number-search-tip"
                                                        left="25px"
                                                        top="25px"
                                                    />
                                                )}
                                            </Stack>
                                        </FormControl>

                                        {/* Search and Clear buttons at the bottom - left aligned */}
                                    </Box>
                                )}
                            </FormBase>
                            <Stack
                                direction="row"
                                spacing={4}
                                mt={2}
                                mb={6}
                                justifyContent="flex-start">
                                <Button
                                    data-walkthroughid={ufSearchButton}
                                    onClick={handleSearchPatched}
                                    className="btn btn-primary"
                                    sx={{ width: 142 }}>
                                    Search
                                </Button>
                                <Button
                                    data-walkthroughid={ufInputClearButton}
                                    onClick={handleClearPatched}
                                    variant="outline"
                                    background="white"
                                    sx={{ width: 142 }}>
                                    Clear
                                </Button>
                            </Stack>
                            {showTable && (
                                <AGGridMain
                                    stateIdentifier="numberBlocksSearchTable"
                                    gridRef={tableRef}
                                    tableData={searchTableData}
                                    isLoading={isLoading}
                                    onColumnVisible={onSearchColumnVisible}
                                    refetch={handleSearchPatched}
                                />
                            )}
                        </Box>
                    </ChakraTabPanel>
                    <ChakraTabPanel p={0}>
                        <Box pt="15px">
                            {loadList && (
                                <>
                                    {blocksLoading && (
                                        <Alert
                                            status="info"
                                            mb={4}
                                            borderRadius="md">
                                            <AlertIcon />
                                            <Box>
                                                <Text>
                                                    Loading Number Blocks for{' '}
                                                    {Scope(currentScope)}...
                                                </Text>
                                                <Text
                                                    fontSize="xs"
                                                    mt={1}
                                                    color="gray.500">
                                                    Tip: Use the Search tab to
                                                    find specific blocks
                                                    instantly.
                                                </Text>
                                            </Box>
                                        </Alert>
                                    )}
                                    <AGGridMain
                                        stateIdentifier="numberBlocksDefaultTable"
                                        gridRef={tableRef}
                                        tableData={defaultTableData}
                                        isLoading={blocksLoading}
                                        onColumnVisible={onDefaultColumnVisible}
                                        refetch={refetchBlocks}
                                        pagination={true}
                                        paginationPageSize={100}
                                        paginationPageSizeSelector={[
                                            50, 100, 250, 500, 1000,
                                        ]}
                                        suppressPaginationPanel={false}
                                        rowBuffer={20}
                                        suppressRowVirtualisation={false}
                                    />
                                    <SplitJoinBlock
                                        isOpen={isSplitJoinOpen}
                                        onClose={() => {
                                            setIsSplitJoinOpen(false);
                                            setSplitJoinId(null);
                                        }}
                                        id={splitJoinId}
                                        state="idle"
                                        setId={setSplitJoinId}
                                    />
                                </>
                            )}
                        </Box>
                    </ChakraTabPanel>
                    {showOrdersTab && (
                        <ChakraTabPanel p={0}>
                            <Box pt="15px">
                                <OrdersTab />
                            </Box>
                        </ChakraTabPanel>
                    )}
                </TabPanels>
            </ChakraTabs>
            {/* SplitJoinBlock modal is now rendered only inside the Number Blocks table tab */}
        </>
    );
}

export default NumberBlocks;
